import { render, staticRenderFns } from "./addCardBtn.vue?vue&type=template&id=0f7c3d8f&scoped=true&"
import script from "./addCardBtn.vue?vue&type=script&lang=js&"
export * from "./addCardBtn.vue?vue&type=script&lang=js&"
import style0 from "./addCardBtn.vue?vue&type=style&index=0&id=0f7c3d8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c3d8f",
  null
  
)

export default component.exports